const formStyle = {
        control: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isDisabled ? "#c4c5c8" : "var(--input-color)",
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            boxShadow: "none",
            minHeight: "45px",
            borderRadius: "25px",
            border: state.isFocused ? "1px solid var(--secondary-color)" : "1px solid transparent",
        }),
        placeholder: (base: any) => ({
            ...base,
            color: "var(--text-color)",
            backgroundColor: "transparent",
            fontSize: "14px",
        }),
        menu: (base: any) => ({
            ...base,
            overflowY: "auto",
            scrollbarWidth: "none",
            color: "var(--text-color)",
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: "160px",
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 3,
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? "#eee" : "",
            color: "var(--text-color)",
            fontSize: "100%",
            zIndex: 3,
        }),
        singleValue: (base: any, state: any) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "var(--text-color)" : state.isSelected ? "var(--text-color)" : "var(--text-color)",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'red',
        }),
    };

export default formStyle;